import { FormMessage, FormMessageVariant } from '@aus-platform/design-system';
import { HaulRoadLayerTypeResponse, type HaulRoadLayer } from 'src/shared/api';
import { HaulRoadDetailsLayer } from './haul-road-layer';

type HaulRoadDetailsLayersProps = {
  haulRoadLayers: HaulRoadLayer[];
  hasBermSupport: boolean;
};

const LAYER_DISPLAY_ORDER = [
  HaulRoadLayerTypeResponse.CenterLine,
  HaulRoadLayerTypeResponse.Edges,
  HaulRoadLayerTypeResponse.Medians,
  HaulRoadLayerTypeResponse.BermAnalysis,
  HaulRoadLayerTypeResponse.GradientAnalysis,
  HaulRoadLayerTypeResponse.WidthAnalysis,
];

export const HaulRoadDetailsLayers: React.FC<HaulRoadDetailsLayersProps> = ({
  haulRoadLayers,
  hasBermSupport,
}) => {
  const requiredLayersCount = hasBermSupport ? 6 : 5;
  const missingLayersCount = requiredLayersCount - haulRoadLayers.length;

  const getMissingLayersMessage = (): string => {
    if (missingLayersCount === requiredLayersCount) {
      return 'All outputs are hidden based on your current layer access permissions.';
    }
    return `${missingLayersCount} ${missingLayersCount > 1 ? 'outputs are' : 'output is'} hidden based on your current layer access permissions.`;
  };

  const layersByType: Partial<Record<HaulRoadLayerTypeResponse, HaulRoadLayer>> =
    Object.fromEntries(haulRoadLayers.map((layer) => [layer.type, layer]));

  const orderedHaulRoadLayers = LAYER_DISPLAY_ORDER.map(
    (layerType) => layersByType[layerType],
  ).filter((layer): layer is HaulRoadLayer => layer !== undefined);

  return (
    <div className="haul-road-details-layers">
      <div className="haul-road-details-layers__title haul-road-details-title">
        <span>Haul Road Layers</span>
        <hr />
      </div>
      <div className="haul-road-details-layers__container">
        {orderedHaulRoadLayers.map((haulRoadLayer: HaulRoadLayer, index) => (
          <HaulRoadDetailsLayer
            key={'haul-road-details-layer' + index}
            haulRoadLayer={haulRoadLayer}
          />
        ))}
        {missingLayersCount > 0 && (
          <FormMessage
            variant={FormMessageVariant.Warning}
            className="haul-road-details-layers__message"
            message={getMissingLayersMessage()}
          />
        )}
      </div>
    </div>
  );
};
